import React, { useRef } from "react";

import { useWizardPersistence } from "../../context/wizardStorage";

interface WizardGuardProps {
  children: React.ReactNode;
}

export const WizardGuard: React.FC<WizardGuardProps> = ({ children }) => {
  const { loading } = useWizardPersistence();
  const hasLoadedRef = useRef(false);

  if (!loading) {
    hasLoadedRef.current = true;
  }

  if (loading && !hasLoadedRef.current) {
    return null;
  }

  return <>{children}</>;
};
